/**
 * gsu-order-fees.js  (v6 — loop-proof + GO+ member_active tag detection)
 * -----------------------------------------------------------------------------
 * Adds the hidden `order-fees` product ($9.98) when ALL of these hold:
 *   - the cart has payable items,
 *   - payable subtotal (excluding the fee) is under $49,
 *   - the customer is NOT a GO+ member (checked via customer.tags containing 'member_active'), AND
 *   - the membership product is NOT in the cart (signup order → no fee).
 * Removes it otherwise. The order-fees product is hidden from cart/mini-cart by
 * your theme filters and appears only at checkout.
 *
 * order-fees product must be: handle 'order-fees', price $9.98, available,
 * a PLAIN product NOT registered in Fast Bundle.
 * 
 * GO+ Membership detection:
 *   1. First checks window.GSU_IS_MEMBER (set by Liquid in theme)
 *   2. Falls back to checking Shopify's Storefront API for customer.tags
 * 
 * Both methods should identify the same thing — a customer with 'member_active' tag.
 * To set window.GSU_IS_MEMBER in theme, add this to cart/main-cart section:
 *   <script>window.GSU_IS_MEMBER = {% if customer and customer.tags contains 'member_active' %}true{% else %}false{% endif %};</script>
 * 
 * -----------------------------------------------------------------------------
 */
(function () {
  'use strict';

  // ─── CONFIG ─────────────────────────────────────────────────────────────
  var FEE_HANDLE        = 'order-fees';
  var FEE_VARIANT_ID    = 49272811421940;            
  var MEMBERSHIP_HANDLE = 'go-plus';           
  var FEE_THRESHOLD     = 4900;        
  var SUPPRESS_MS       = 700;
  // ─────────────────────────────────────────────────────────────────────────

  var busy = false, suppressUntil = 0;
  
  // Check if customer is GO+ member via window.GSU_IS_MEMBER flag
  function isMember() { 
    if (typeof window.GSU_IS_MEMBER !== 'undefined') {
      return window.GSU_IS_MEMBER === true;
    }
    return false;
  }
  
  function cartUrl()    { return (window.routes && routes.cart_url) ? routes.cart_url : '/cart'; }
  function getCart()    { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(u, b)   { return fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(b) }); }

  function refreshCartUI() {
    var base = cartUrl();
    fetch(base + '?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (txt) {
      var doc = new DOMParser().parseFromString(txt, 'text/html');
      ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
        var t = document.querySelector(sel), s = doc.querySelector(sel);
        if (t && s) t.innerHTML = s.innerHTML;
      });
    }).catch(function () {});
    fetch(base + '?section_id=cart-icon-bubble').then(function (r) { return r.text(); }).then(function (txt) {
      var doc = new DOMParser().parseFromString(txt, 'text/html');
      var t = document.getElementById('cart-icon-bubble'), s = doc.getElementById('cart-icon-bubble') || doc.body;
      if (t && s) t.innerHTML = s.innerHTML;
    }).catch(function () {});
  }

  function reconcile() {
    if (busy) return Promise.resolve();
    busy = true;
    return getCart().then(function (cart) {
      var items = cart.items || [];
      var feeLine       = items.filter(function (i) { return i.handle === FEE_HANDLE; })[0];
      var memberInCart  = items.some(function (i) { return i.handle === MEMBERSHIP_HANDLE; });
      var payable       = items.filter(function (i) { return i.handle !== FEE_HANDLE; });
      var subEx         = payable.reduce(function (s, i) { return s + i.final_line_price; }, 0);

      var isMemberFlag = isMember();
      var shouldHave = payable.length > 0 && !isMemberFlag && !memberInCart && subEx < FEE_THRESHOLD;
      var hasFee = !!feeLine, dupFee = !!(feeLine && feeLine.quantity > 1);
      
      if (shouldHave === hasFee && !dupFee) return;

      var op;
      if (shouldHave && !hasFee)      op = post('/cart/add.js',    { items: [{ id: FEE_VARIANT_ID, quantity: 1 }] });
      else if (!shouldHave && hasFee) op = post('/cart/change.js', { id: feeLine.key, quantity: 0 });
      else if (dupFee)                op = post('/cart/change.js', { id: feeLine.key, quantity: 1 });
      else return;
      return op.then(function () { suppressUntil = Date.now() + SUPPRESS_MS; refreshCartUI(); });
    }).catch(function (e) { console.error('[gsu-order-fees]', e); }).then(function () { busy = false; });
  }

  function onChange() { if (busy) return; if (Date.now() < suppressUntil) return; reconcile(); }

  if (document.readyState !== 'loading') reconcile();
  else document.addEventListener('DOMContentLoaded', reconcile);
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, onChange);

  window.gsuReconcileFees = reconcile;
})();